/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_Asset_TypeInputs */

const cs_investor_asset_type = /** @type {(inputs: Investor_Asset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ aktiva`)
};

const en_investor_asset_type = /** @type {(inputs: Investor_Asset_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset type`)
};

/**
* | output |
* | --- |
* | "Asset type" |
*
* @param {Investor_Asset_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_asset_type = /** @type {((inputs?: Investor_Asset_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_Asset_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_asset_type(inputs)
	return cs_investor_asset_type(inputs)
});